import React from 'react';
import UIComponent from 'ui-components/ui-component';
import SelectGroup from 'ui-components/select-grid/select-group';
import SelectGrid from 'ui-components/select-grid/select-grid';
import ResInterface from '../../interface/res-interface';
import EventCenter from 'global-libs/old-event/event-center';

export default class Menu extends UIComponent{
    awake(){
        super.awake();
        //获取资源类型
        ResInterface.getAvailableTypes((json)=>{
            if(json["tag"]){
                this.setState({items:json["result"]});
            }
        });
    }
    get className(){
        return "main-menu";
    }
    get isRegisterEvent(){
        return false;
    }
    initState(){
        let state = super.initState();
        state.items = [];
        return state;
    }
    get defaultSelectTagName(){
        return this.state.items.length!==0?this.state.items[0]["res_type_id"]:"";
    }
    get initChildren(){
        let Grids = [];
        this.state.items.forEach((item)=>{
            Grids.push(<SelectGrid key={item["res_type_id"]} tagName={item["res_type_id"]} className="menu-item">{item["resource_type"]}</SelectGrid>);
        });
        return Grids;
    }
    render(){
        return <SelectGroup className={this.className} selectedTagName={this.defaultSelectTagName} onValueChange={(remove,add)=>{
            if(add!==undefined&&add!==""){
                ResInterface.getResByType(add,(json)=>{
                    if(json["tag"]){
                        EventCenter.fire({
                           type:"refresh-res",
                           data:json["result"]
                        });
                    }
                })
            }
        }}>
            {this.initChildren}
        </SelectGroup>
    }
}